/**
 * The external documentation portal. The in-app /docs pages were retired in
 * favour of it; /docs and /docs/api now forward here (routes/ExternalRedirect).
 *
 * Resolution follows the API base URLs (services/api/client.js):
 *   1. Runtime config  - window.env.REACT_APP_DOCS_URL (env-config.js, envsubst)
 *   2. Build-time      - process.env.REACT_APP_DOCS_URL
 *   3. Default         - https://docs.saf3ai.com
 * An empty value (envsubst writes '' for an unset variable) falls through.
 */
const DEFAULT_DOCS_URL = 'https://docs.saf3ai.com';

const pick = (value) => (typeof value === 'string' && value.trim() ? value.trim() : null);

const runtime = typeof window !== 'undefined' && window.env ? window.env.REACT_APP_DOCS_URL : undefined;
const buildTime = typeof process !== 'undefined' && process.env ? process.env.REACT_APP_DOCS_URL : undefined;

export const DOCS_URL = (pick(runtime) || pick(buildTime) || DEFAULT_DOCS_URL).replace(/\/+$/, '');

/** A page under the docs portal, e.g. docsUrl('/sdk/overview'). */
export const docsUrl = (path = '') => (path ? `${DOCS_URL}/${String(path).replace(/^\/+/, '')}` : DOCS_URL);
